exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container---S-ERo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 45px;\n  margin: 0 auto; }\n\n.icon---1ukXg {\n  float: left;\n  width: 14px;\n  height: 15px;\n  margin-right: 2px;\n  opacity: 0.3; }\n\n.count---1-gEk {\n  color: #444;\n  font-family: Poppins;\n  font-size: 13px; }\n", ""]);

// exports
exports.locals = {
	"container": "container---S-ERo",
	"icon": "icon---1ukXg",
	"count": "count---1-gEk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/student-count/index.scss
// module id = 1188
// module chunks = 3